import { ISearchResultComponentFactory } from "../interfaces";

const description: ISearchResultComponentFactory<string> = {

    key: "description",

    createElement: value => {
        const style = document.getElementById('filter-page-results')?.getAttribute('data-results-style');
        const classes = style == "Compact" ? "mt-2 text-md truncate" : "mt-2 text-md";

        const element = document.createElement('p');
        element.className = classes;

        const termInput = document.querySelector('form input[name="term"]');
        if (termInput instanceof HTMLInputElement) {
            value = highlightTerm(value, termInput.value);
        }

        element.innerHTML = value;
        element.className = classes;
        return element;
    },
};

function highlightTerm(value: string, terms: string): string {

    terms.split(" ").forEach(term => {
        try {
            const escapedTerm = term.replace(/[.*+?^=!:${}()|[\]/\\]/g, '\\$&');
            const regex = new RegExp(`(${escapedTerm})`, 'gi');
            value = value.replace(regex, `<strong>${term}</strong>`);
        } catch (e) {
            console.log(`could not replace ${term} in value`, e);
        }
    });

    return value;
}

export default description;
